import React from "react";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const Field = ({ label, children, testid }) => (
  <div className="space-y-1.5" data-testid={testid}>
    <Label className="text-xs uppercase tracking-wider text-slate-500">{label}</Label>
    {children}
  </div>
);

export const TextField = ({ label, value, onChange, testid, type = "text", required }) => (
  <Field label={label}>
    <Input type={type} value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} required={required} />
  </Field>
);

export const AreaField = ({ label, value, onChange, testid, rows = 3 }) => (
  <Field label={label}>
    <Textarea rows={rows} value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} />
  </Field>
);

export const SelectField = ({ label, value, onChange, options, testid }) => (
  <Field label={label}>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testid}><SelectValue /></SelectTrigger>
      <SelectContent>
        {options.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
      </SelectContent>
    </Select>
  </Field>
);

export const SwitchField = ({ label, checked, onChange, testid }) => (
  <div className="flex items-center justify-between rounded-xl border border-slate-200 px-4 py-3">
    <span className="text-sm font-medium text-navy-900">{label}</span>
    <Switch checked={!!checked} onCheckedChange={onChange} data-testid={testid} />
  </div>
);

export const EditorDialog = ({ open, onClose, title, onSave, saving, children, testid }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid={testid}>
      <DialogHeader><DialogTitle className="font-display text-2xl text-navy-900">{title}</DialogTitle></DialogHeader>
      <form onSubmit={(e) => { e.preventDefault(); onSave(); }} className="space-y-4">
        {children}
        <DialogFooter className="pt-2">
          <Button type="button" variant="outline" className="rounded-full" onClick={onClose} data-testid="editor-cancel-btn">Cancel</Button>
          <Button type="submit" disabled={saving} className="rounded-full bg-navy-900 hover:bg-navy-700 text-white" data-testid="editor-save-btn">
            {saving && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Save
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);

export const EmptyState = ({ text }) => <div className="p-16 text-center text-slate-400" data-testid="admin-empty-state">{text}</div>;
export const Spinner = () => <div className="p-16 text-center"><Loader2 className="h-6 w-6 animate-spin mx-auto text-navy-900" /></div>;
